import { Maybe } from "true-myth";
import { find, propEq, without } from "ramda";

import { FilterActionTypes, FilterTypeKeys } from "actions/scheduling/filters";

import { toggleArrayItem } from "helpers/collections";
import { ICategoryWithRoles } from "helpers/schedule/action_bar/filters";
import { IScheduleFilters } from "types/reducers";
import union from "ramda/es/union";
import difference from "ramda/es/difference";

const initialState: IScheduleFilters = {
  roles: [],
};

export default function scheduling(
  state: IScheduleFilters = initialState,
  action: FilterActionTypes
): IScheduleFilters {
  switch (action.type) {
    case FilterTypeKeys.CLEAR_FILTERS: {
      return initialState;
    }

    case FilterTypeKeys.TOGGLE_CATEGORY: {
      const { allCategoriesWithRoles, category } = action;
      const { roles } = state;
      const allCategoryRoles: Maybe<ICategoryWithRoles> = Maybe.of(
        find(propEq("name", category), allCategoriesWithRoles)
      );
      const newRoles = allCategoryRoles.match({
        Just: (categoryRoles: ICategoryWithRoles) => {
          // Check if the category is currently fully selected
          const unselectedRoles = difference(categoryRoles.roles, roles);
          if (unselectedRoles.length === 0) {
            // Remove all currently selected roles
            return without(categoryRoles.roles, roles);
          } else {
            // Otherwise select everything in this category
            return union(categoryRoles.roles, roles);
          }
        },
        Nothing: () => roles,
      });

      return {
        ...state,
        roles: newRoles,
      };
    }

    case FilterTypeKeys.TOGGLE_ROLE: {
      const { role } = action;
      return {
        ...state,
        roles: toggleArrayItem(role, state.roles),
      };
    }

    default: {
      return state;
    }
  }
}
